module.exports = __webpack_public_path__ + "asset/titleIcon_18h81T_C.png";